import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Styled <br> to cooperate with serialization via styled-components
const StyledBr = styled.br``;

export const Br = ({ attributes, className }) => (
  // For void inline elements, Slate passes children but we don't render them
  <StyledBr {...attributes} className={className} />
);

Br.propTypes = {
  attributes: PropTypes.elementType,
  className: PropTypes.string,
  element: PropTypes.object,
};

Br.defaultProps = {
  attributes: [],
  className: '',
  element: {},
};

const defaultBr = {
  br: {
    component: Br,
    type: 'br',
    isInline: true,
    isVoid: true,
    rootProps: {
      className: 'slate-br',
    },
  },
};

export default defaultBr;
